module.exports = __webpack_public_path__ + "static/media/7.523feb24.JPG";